// Numbered pagination for admin tables (KAN-73). Right-aligned Prev / page
// numbers (with ellipsis) / Next, matching the admin button styling.

function pageWindow(page, total) {
  const wanted = new Set([1, total, page, page - 1, page + 1]);
  const shown = [...wanted].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const out = [];
  let prev = 0;
  for (const p of shown) {
    if (p - prev > 1) out.push("…");
    out.push(p);
    prev = p;
  }
  return out;
}

export default function AdminPagination({ page, totalPages, onPageChange, testid = "admin-pagination" }) {
  if (!totalPages || totalPages <= 1) return null;
  const go = (p) => {
    if (p >= 1 && p <= totalPages && p !== page) onPageChange(p);
  };
  return (
    <nav
      className="px-4 sm:px-6 py-4 border-t border-[var(--zc-border)] flex items-center justify-end gap-1.5 flex-wrap"
      aria-label="pagination"
      data-testid={testid}
    >
      <span className="text-xs text-[var(--zc-text-3)] mr-1">Page {page} of {totalPages}</span>
      <button
        type="button"
        onClick={() => go(page - 1)}
        disabled={page <= 1}
        className="px-3 h-9 zc-btn-ghost text-xs disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`${testid}-prev`}
      >
        Prev
      </button>
      {pageWindow(page, totalPages).map((p, i) =>
        p === "…" ? (
          <span key={`ellipsis-${i}`} className="px-1.5 text-xs text-[var(--zc-text-3)]" aria-hidden>
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => go(p)}
            aria-current={p === page ? "page" : undefined}
            className={`min-w-9 h-9 px-2 text-xs rounded-full ${p === page ? "zc-btn-primary text-white" : "zc-btn-ghost"}`}
            data-testid={`${testid}-page-${p}`}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        onClick={() => go(page + 1)}
        disabled={page >= totalPages}
        className="px-3 h-9 zc-btn-ghost text-xs disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`${testid}-next`}
      >
        Next
      </button>
    </nav>
  );
}
